import { ReportTemplateDto } from "@/core/features/report-templates/report-template.dto";
import { TechnicalReportStatusEnum } from "@altertec_gparn/lib";
import { FileDto } from "@/core/features/file/file.dto";
import { ProjectDto } from "@/core/features/projects/project.dto";
import { TechnicalReportSectionDto } from "@/core/features/technical-report-sections/technical-report-section.dto";
import { Type } from "class-transformer";
import { AssetDto } from "@/core/features/assets/asset.dto";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class TechnicalReportDto extends BaseEntityDto {
  @Type(() => ReportTemplateDto)
  reportTemplate: ReportTemplateDto;
  reportTemplateId: string;

  @Type(() => ProjectDto)
  project: ProjectDto;
  projectId: string;

  @Type(() => AssetDto)
  asset: AssetDto;
  assetId: string;

  status: TechnicalReportStatusEnum;

  @Type(() => FileDto)
  finalReportFile: FileDto;
  finalReportFileId: string;

  @Type(() => TechnicalReportSectionDto)
  technicalReportSections: TechnicalReportSectionDto[];
}
